module.exports = __webpack_public_path__ + "img/86.bfff29ba.jpg";